<div #content [ngClass]="'card-chain -container ' + parentClass">
  <ng-content></ng-content>
  <div *ngIf="displayline === true" class="card-chain -white-line" [ngStyle]="{'width': chainWidth}"></div>
</div>
